import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Dashboard from './dashboard'; // Make sure to import your main component
import Login from './Login';
import Register from './Register';
import SoftwareRequirements from './SoftwareRequirements';
import Products from './Products';
import AboutUs from './AboutUs';
import AiVoiceAssistant from './AiVoiceAssistant';

const Main = () => (
  <Routes>
    <Route path="/" element={<Dashboard />} /> {/* Use Dashboard as main component */}
    <Route path="/login" element={<Login />} />
    <Route path='/register' element={<Register />}/>
    <Route path='/softwarerequirements' element={<SoftwareRequirements/>} />
    <Route path='/products' element={<Products/>}/>
    <Route path='/dashboard' element={<Dashboard/>}/>
    <Route path='/aboutus' element={<AboutUs/>}/>
    <Route path='/aivoiceassistant' element={<AiVoiceAssistant/>} />
    {/* Add more routes as needed */}
  </Routes>
);

export default Main;
